var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotifFilePdf(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/PDF",
    clipPath: "url(#clip0_0_103)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.6297 24H9.26978C7.40808 24 5.89888 22.5007 5.89888 20.6512V3.34884C5.89888 1.49933 7.40808 0 9.26978 0H16.9948L25.0006 7.95349V20.6512C25.0006 22.5007 23.4914 24 21.6297 24Z",
    fill: "#F2F6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.89888 20.6512V3.34884C5.89888 1.49933 7.40808 0 9.26978 0H16.9948L25.0006 7.95349V20.6512C25.0006 22.5007 23.4914 24 21.6297 24V22.8837C22.8709 22.8837 23.877 21.8842 23.877 20.6512V8.51163H20.3657C18.1937 8.51163 16.4329 6.76241 16.4329 4.60465V1.11628H9.26978C8.02865 1.11628 7.02251 2.11583 7.02251 3.34884V20.6512C7.02251 21.8842 8.02865 22.8837 9.26978 22.8837L9.26978 24L9.18282 23.9989C7.36131 23.9531 5.89888 22.4718 5.89888 20.6512ZM21.6297 22.8837V24H9.26978L9.26978 22.8837H21.6297ZM17.5566 4.60465C17.5566 6.14591 18.8142 7.39535 20.3657 7.39535H22.8499L17.5566 2.13663V4.60465Z",
    fill: "#C3C3C3"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rounded Rectangle",
    y: 10.6047,
    width: 16.8545,
    height: 9.76744,
    rx: 2,
    fill: "#FF716D"
  }), /*#__PURE__*/React.createElement("g", {
    id: "PDF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.79317 17.8605V13.1924H4.46805C4.83362 13.1924 5.13647 13.2585 5.37661 13.3907C5.61675 13.5229 5.79648 13.7037 5.91578 13.9332C6.03509 14.1611 6.09474 14.4179 6.09474 14.7036C6.09474 14.9908 6.03433 15.2491 5.91349 15.4786C5.79418 15.7065 5.6137 15.8873 5.37202 16.021C5.13188 16.1532 4.82979 16.2193 4.46575 16.2193H3.31399V15.6222H4.40151C4.63248 15.6222 4.81985 15.5826 4.96363 15.5036C5.10741 15.4231 5.21295 15.3137 5.28025 15.1754C5.34755 15.0371 5.3812 14.8798 5.3812 14.7036C5.3812 14.5273 5.34755 14.3708 5.28025 14.234C5.21295 14.0973 5.10664 13.9901 4.96133 13.9127C4.81756 13.8352 4.62789 13.7964 4.39234 13.7964H3.50213V17.8605H2.79317Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.44703 17.8605H6.92587V13.1924H8.49521C8.95561 13.1924 9.351 13.2858 9.68139 13.4727C10.0118 13.6581 10.2649 13.9248 10.4408 14.2728C10.6182 14.6192 10.707 15.0348 10.707 15.5196C10.707 16.0058 10.6175 16.4237 10.4385 16.7732C10.2611 17.1227 10.0041 17.3917 9.66762 17.5801C9.33112 17.767 8.92425 17.8605 8.44703 17.8605ZM7.63483 17.245H8.40802C8.76594 17.245 9.06344 17.1782 9.30053 17.0445C9.53761 16.9092 9.71504 16.714 9.83282 16.4587C9.95059 16.2019 10.0095 15.8888 10.0095 15.5196C10.0095 15.1534 9.95059 14.8426 9.83282 14.5873C9.71657 14.332 9.54296 14.1383 9.312 14.0061C9.08103 13.8739 8.79424 13.8078 8.45162 13.8078H7.63483V17.245Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5886 17.8605V13.1924H14.5024V13.7987H12.2975V15.221H14.2936V15.825H12.2975V17.8605H11.5886Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_103"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifFilePdf);
export default __webpack_public_path__ + "static/media/notif-file-pdf.0e9ccc9739527257b751e66bb5eb0f18.svg";
export { ForwardRef as ReactComponent };